import { render, staticRenderFns } from "./fifthStep.vue?vue&type=template&id=442d05d3&scoped=true&slot=groupTitle&"
import script from "./fifthStep.vue?vue&type=script&lang=js&"
export * from "./fifthStep.vue?vue&type=script&lang=js&"
import style0 from "./fifthStep.vue?vue&type=style&index=0&id=442d05d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442d05d3",
  null
  
)

export default component.exports